<template>
  <v-app id="app">
    <router-view />
    <loader
      :loaderOn="loaderOn"
      :linearLoader="$store.state.loader.linearLoader"
      :circleLoader="$store.state.loader.circleLoader"
    ></loader>
    <confirm-message
      :message="$store.state.confirmMessage.message"
      :title="$store.state.confirmMessage.title"
      :type="$store.state.confirmMessage.type"
      :btConfirm="$store.state.confirmMessage.btConfirm"
      :btCancel="$store.state.confirmMessage.btCancel"
      :btExtra="$store.state.confirmMessage.btExtra"
      :listaLink="$store.state.confirmMessage.listaLink"
      :textForm="$store.state.confirmMessage.textForm"
      :callback="$store.state.confirmMessage.callback"
      :messageForm="$store.state.confirmMessage.messageForm"
      :selectMenu="$store.state.confirmMessage.selectMenu"
      :selectMenuForm="$store.state.confirmMessage.selectMenuForm"
      :maxLengthItem="$store.state.confirmMessage.maxLengthItem"
    ></confirm-message>
    <modal-video
    :codigo="$store.state.tutorial.codigo"
    :title="$store.state.tutorial.title"
    :modalVideo="$store.state.tutorial.modalVideo"
    ></modal-video>
  </v-app>
</template>

<script>
// @ is an alias to /src
import loader from "./components/common/Loader";
import confirmMessage from "./components/common/ConfirmMessage";
import modalVideo from "./components/common/modalVideo";
export default {
  name: "home",
  components: {
    loader,
    confirmMessage,
    modalVideo
  },
  computed: {
    loaderOn: function() {
      return this.$store.state.loader.loaderOn;
    }
  }
};
</script>
